// A17 — THE RING TARGET PICKER. Brief 65 (brief 50 §4), the thirteenth of the sixteen.
//
// Who a call's WebRTC signalling should be sent to, from that call's row.
//
//   src/App.tsx:4943-4951@8fdbbd6c x src/App.tsx:4952-4961@8fdbbd6c  80.9%
//
// TWO DIFFERENCES, TWO PARAMETERS (§2), and neither is a choice between the two
// copies' behaviour:
//
//   WHICH OUTCOMES COUNT  the mesh sends to participants who have answered OR
//                         are still ringing; the armed set sends only to those
//                         who have answered
//   WHETHER I AM IN YET   the armed set returns nothing at all until I have
//                         accepted (`iAmCommitted`); the mesh set does not ask
//
// The initiator arm is the same in both — everyone but me, unless they have
// left — so it is not a parameter.
//
// `iAmCommitted` stays in App.tsx: it is a separate declaration, in no census
// pair, and this commit moves one candidate (rule 3). It is passed in as the
// gate rather than re-implemented here, so there is exactly one definition of
// "I have accepted this call" and it is still the one the rest of that file
// uses.

type CallRow = {
  initiatorId?: unknown;
  initiatorLeftAt?: unknown;
  participants?: Array<{ collaboratorId?: unknown; outcome?: unknown }>;
};

export function pickRingTargets(
  callRow: CallRow,
  me: number,
  opts: { outcomes: unknown[]; gate?: (row: CallRow, me: number) => boolean },
) {
  if (opts.gate && !opts.gate(callRow, me)) return []; // I haven't accepted → send to no one
  const out = [];
  if (Number(callRow.initiatorId) !== me && !callRow.initiatorLeftAt)
    out.push(Number(callRow.initiatorId));
  for (const p of callRow.participants || []) {
    if (Number(p.collaboratorId) !== me && opts.outcomes.includes(p.outcome))
      out.push(Number(p.collaboratorId));
  }
  return out;
}
